module.exports = __webpack_public_path__ + "img/signout-white.1cc5148e.svg";